import {BoxProps, Button, ButtonProps, Heading, HeadingProps, Icon, Text, TextProps} from "@chakra-ui/react";
import NextLink from "next/link";
import {Container} from "./Container";
import {ArrowRightIcon} from "@heroicons/react/24/solid";

export const HeroContainer = (props: BoxProps) => <Container pt={[24, 24, 24, 32]} pb={[16, 16, 16, 24]} {...props} />;

export const HeroHeading = (props: HeadingProps) => (
  <Heading
    fontSize={["3xl", "3xl", "3xl", "4xl", "5xl"]}
    fontWeight={600}
    color="gray.100"
    letterSpacing="tight"
    textShadow="0px 1px 5px rgba(0,0,0,.1)"
    lineHeight="normal"
    {...props}
  />
);

export const HeroEm = (props: TextProps) => (
  <Text as="em" fontWeight="semibold" color="white" display="inline" fontStyle="unset" {...props} />
);

export const HeroText = (props: TextProps) => <Text fontSize={["md", "lg", "lg", "xl"]} color="gray.50" {...props} />;

export const HeroButton = ({to, colorPalette, children, ...props}: {to: string} & ButtonProps) => (
  <Button
    asChild
    colorPalette={colorPalette}
    rounded="full"
    border="3px solid"
    borderColor="{colors.colorPalette.300}"
    size="lg"
    {...props}
  >
    <NextLink href={to}>
      {children}
      <Icon size="md">
        <ArrowRightIcon />
      </Icon>
    </NextLink>
  </Button>
);
